import React from 'react'
import TextField from '../atoms/TextField/TextField'
const InputPassword = (props) => {
    return (
        <TextField {...props} type='password' />
    )
}

export default InputPassword
